'use client';

import { EquipmentWidgetRedesigned } from '../equipment-widget-redesigned/equipment-widget-redesigned';
import type { SelectedEquipmentInfo as SelectedEquipmentInfoType } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { usePathMatch } from 'hooks/use-path-match';
import { CURRENT_PAGE } from 'app/[lang]/[esite]/(core)/_header/components/store/constants';

const EquipmentWidgetSelector = ({
  children,
  widgetContent,
  hasEquipmentsToSelect,
  isEquipmentSelected,
  selectedEquipmentInfo,
  PLPMobileUpdatesFlag = false,
  mobileWidgetSearchFlag = false,
  shouldTriggerNER
}: {
  selectedEquipmentInfo: SelectedEquipmentInfoType;
  children: React.ReactNode;
  widgetContent: React.ReactNode;
  hasEquipmentsToSelect: boolean;
  isEquipmentSelected: boolean;
  PLPMobileUpdatesFlag?: boolean;
  mobileWidgetSearchFlag?: boolean;
  shouldTriggerNER: boolean;
}) => {
  const isSearchPage = usePathMatch(CURRENT_PAGE[1].path);
  const isCategoryPage = usePathMatch(CURRENT_PAGE[0].path);
  if (
    (isCategoryPage && PLPMobileUpdatesFlag) ||
    (isSearchPage && mobileWidgetSearchFlag)
  ) {
    return (
      <EquipmentWidgetRedesigned
        hasEquipmentsToSelect={hasEquipmentsToSelect}
        widgetContent={widgetContent}
        isEquipmentSelected={isEquipmentSelected}
        selectedEquipmentInfo={selectedEquipmentInfo}
        shouldTriggerNER={shouldTriggerNER}
      />
    );
  }

  return children;
};

export default EquipmentWidgetSelector;
